/* Swanky Cycles — theme.js */
(function () {
  'use strict';

  /* ── Helpers ──────────────────────────────────────────────────────────── */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ── Cart drawer state ────────────────────────────────────────────────── */
  var drawer  = document.getElementById('CartDrawer');
  var overlay = document.getElementById('CartOverlay');
  var drawerBody   = document.getElementById('CartDrawerBody');
  var drawerFooter = document.getElementById('CartDrawerFooter');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.classList.add('open'); overlay.setAttribute('aria-hidden', 'false'); }
    document.body.classList.add('drawer-open');
    var closeBtn = document.getElementById('CartDrawerClose');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) { overlay.classList.remove('open'); overlay.setAttribute('aria-hidden', 'true'); }
    document.body.classList.remove('drawer-open');
  }

  if (overlay) overlay.addEventListener('click', closeDrawer);

  var cartCloseBtn = document.getElementById('CartDrawerClose');
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ── Cart announce (screen readers) ──────────────────────────────────── */
  var cartAnnounce = document.getElementById('CartAnnounce');
  function announceCart(cart) {
    if (!cartAnnounce) return;
    if (!cart || cart.item_count === 0) {
      cartAnnounce.textContent = 'Cart is empty.';
    } else {
      cartAnnounce.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' in cart. Total: $' + (cart.total_price / 100).toFixed(2) + '.';
    }
  }

  /* ── Cart badge ───────────────────────────────────────────────────────── */
  function updateBadge(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
      if (count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  /* ── Render cart drawer ───────────────────────────────────────────────── */
  function renderDrawer(cart) {
    if (!drawerBody || !drawerFooter) return;

    if (!cart || cart.item_count === 0) {
      drawerBody.innerHTML =
        '<div class="drawer-empty">' +
          '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" style="margin:0 auto 20px;display:block;color:var(--line)"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>' +
          '<p>Your cart is empty.</p>' +
          '<a href="/collections/all" class="btn btn-primary">Browse bikes</a>' +
        '</div>';
      drawerFooter.innerHTML = '';
      return;
    }

    /* Build item HTML */
    var itemsHtml = cart.items.map(function (item, i) {
      var imgTag = item.image
        ? '<img src="' + item.image.replace(/(\.\w+)(\?|$)/, '_120x120$1$2') + '" alt="' + item.title.replace(/"/g, '&quot;') + '" width="70" height="70" loading="lazy">'
        : '';
      var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="drawer-item-variant">' + item.variant_title + '</div>'
        : '';
      return '' +
        '<div class="drawer-item">' +
          '<a href="' + item.url + '" class="drawer-item-img">' + imgTag + '</a>' +
          '<div class="drawer-item-info">' +
            '<a href="' + item.url + '" class="drawer-item-name">' + item.product_title + '</a>' +
            variantLine +
            '<div class="drawer-item-row">' +
              '<div class="drawer-qty">' +
                '<button class="drawer-qty-btn" data-line="' + (i + 1) + '" data-delta="-1" aria-label="Decrease quantity">−</button>' +
                '<span class="drawer-qty-num">' + item.quantity + '</span>' +
                '<button class="drawer-qty-btn" data-line="' + (i + 1) + '" data-delta="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<div class="drawer-item-price">' + money(item.final_price) + '</div>' +
            '</div>' +
          '</div>' +
          '<button class="drawer-item-remove" data-line="' + (i + 1) + '" aria-label="Remove ' + item.product_title.replace(/"/g, '&quot;') + '">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
          '</button>' +
        '</div>';
    }).join('');

    drawerBody.innerHTML = itemsHtml;

    /* Footer */
    drawerFooter.innerHTML =
      '<div class="drawer-subtotal">' +
        '<span>Subtotal</span>' +
        '<strong>' + money(cart.total_price) + '</strong>' +
      '</div>' +
      '<p class="drawer-shipping-note">Shipping calculated at checkout</p>' +
      '<a href="' + (document.body.dataset.checkoutUrl || '/checkout') + '" class="btn btn-primary btn-block drawer-checkout-btn">Proceed to Checkout</a>' +
      '<a href="/cart" class="drawer-view-cart">View full cart</a>';

    /* Wire qty buttons */
    drawerBody.querySelectorAll('.drawer-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line    = parseInt(btn.dataset.line, 10);
        var delta   = parseInt(btn.dataset.delta, 10);
        var numEl   = btn.parentNode.querySelector('.drawer-qty-num');
        var current = parseInt(numEl.textContent, 10);
        var newQty  = Math.max(0, current + delta);
        btn.disabled = true;
        postJSON('/cart/change.js', { line: line, quantity: newQty })
          .then(function (updatedCart) {
            renderDrawer(updatedCart);
            updateBadge(updatedCart.item_count);
            announceCart(updatedCart);
          });
      });
    });

    /* Wire remove buttons */
    drawerBody.querySelectorAll('.drawer-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.dataset.line, 10);
        btn.disabled = true;
        postJSON('/cart/change.js', { line: line, quantity: 0 })
          .then(function (updatedCart) {
            renderDrawer(updatedCart);
            updateBadge(updatedCart.item_count);
            announceCart(updatedCart);
          });
      });
    });
  }

  /* ── Open drawer and refresh cart ────────────────────────────────────── */
  function openAndRefresh() {
    openDrawer();
    if (drawerBody) drawerBody.innerHTML = '<div class="cart-loading">Loading…</div>';
    getJSON('/cart.js').then(function (cart) {
      renderDrawer(cart);
      updateBadge(cart.item_count);
    });
  }

  /* Cart icon toggle button(s) */
  document.querySelectorAll('#CartToggle, [data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openAndRefresh();
    });
  });

  /* ── Add to Cart (AJAX) ───────────────────────────────────────────────── */
  var atcForm = document.getElementById('AddToCartForm');
  if (atcForm) {
    atcForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var idInput = atcForm.querySelector('input[name="id"]');
      if (!idInput) return;
      var variantId = parseInt(idInput.value, 10);

      /* Disable all ATC buttons */
      var atcBtns = document.querySelectorAll('[data-atc-btn]');
      atcBtns.forEach(function (b) {
        b.disabled = true;
        b.textContent = 'Adding…';
      });

      postJSON('/cart/add.js', { id: variantId, quantity: 1 })
        .then(function (result) {
          if (result.id) {
            /* Success — restore button text, open drawer */
            atcBtns.forEach(function (b) {
              b.textContent = 'Added ✓';
            });
            getJSON('/cart.js').then(function (cart) {
              renderDrawer(cart);
              updateBadge(cart.item_count);
              announceCart(cart);
              openDrawer();
            });
            setTimeout(function () {
              atcBtns.forEach(function (b) {
                var orig = b.dataset.origText || 'Add to Cart';
                b.textContent = orig;
                b.disabled = false;
              });
            }, 2000);
          } else {
            throw new Error(result.description || 'Could not add to cart');
          }
        })
        .catch(function () {
          atcBtns.forEach(function (b) {
            b.textContent = 'Error — try again';
            b.disabled = false;
          });
        });
    });
  }

  /* ── Variant selector ─────────────────────────────────────────────────── */
  var productData = window.swankyProduct;
  if (productData && productData.variants && atcForm) {
    var selects = Array.from(atcForm.querySelectorAll('select[name^="options"]'));

    function findVariant() {
      var chosen = selects.map(function (s) { return s.value; });
      return productData.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }

    function syncVariant() {
      var v = findVariant();
      if (!v) return;

      /* Update hidden variant ID */
      var hiddenId = atcForm.querySelector('input[name="id"]');
      if (hiddenId) hiddenId.value = v.id;

      /* Update prices */
      var priceNow = document.getElementById('PdpPriceNow');
      if (priceNow) priceNow.textContent = money(v.price);

      var priceWas = document.getElementById('PdpPriceWas');
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = money(v.compare_at_price) + ' RRP';
          priceWas.removeAttribute('hidden');
        } else {
          priceWas.textContent = '';
          priceWas.setAttribute('hidden', '');
        }
      }

      /* Update sticky price */
      var stickyPrice = document.getElementById('StickyPrice');
      if (stickyPrice) stickyPrice.textContent = money(v.price);

      /* Update ATC buttons */
      document.querySelectorAll('[data-atc-btn]').forEach(function (btn) {
        btn.disabled = !v.available;
        var label = v.available
          ? (btn.id === 'AtcBtn' ? 'Add to Cart · ' + money(v.price) : 'Add to Cart')
          : 'Sold Out';
        btn.textContent = label;
        btn.dataset.origText = label;
      });
    }

    selects.forEach(function (s) { s.addEventListener('change', syncVariant); });
    syncVariant(); /* sync on load */
  }

  /* ── Mobile menu ──────────────────────────────────────────────────────── */
  var mobileMenu = document.getElementById('MobileMenu');

  document.querySelectorAll('.mobile-menu-open').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mobileMenu) return;
      mobileMenu.classList.add('open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
    });
  });

  document.querySelectorAll('.mobile-menu-close').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      var openBtn = document.querySelector('.mobile-menu-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    });
  });

  /* ── PDP gallery thumbs ───────────────────────────────────────────────── */
  document.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('PdpMainImg');
      if (mainImg) {
        mainImg.src = thumb.dataset.full || thumb.querySelector('img').src;
      }
      document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

})();
